// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import LayoutHeader from './components/layout/Header'
import LayoutHeadercomponents from './components/layout/Headercomponents'
import LayoutNavbar from './components/layout/Navbar'
import LayoutNavbaremail from './components/layout/Navbaremail'
import VueProgressBar from 'vue-progressbar'
// const Popper = require('@popperjs/core')
// const Bootstrap = require('bootstrap')
// Bootstrap.Modal.constructor.prototype.enforceFocus = () => {}
import 'bootstrap/dist/css/bootstrap.css'
import VueToastify from 'vue-toastify'
import VueConfirmDialog from './components/vue-confirm-dialog'
import VueSweetalert2 from 'vue-sweetalert2';
import Vlf from 'vlf'
import localforage from 'localforage'
import 'sweetalert2/dist/sweetalert2.min.css';
import './assets/css/font-awesome-7.2.0.min.css'
//import './assets/css/font-awesome.min.css'
import './assets/css/feather.css'
import './assets/css/line-awesome.min.css'
import 'vant/lib/index.css'
import i18n from '@/utils/i18n';
require('./assets/css/style.css');
require('./assets/css/dkl-style.css');
Vue.config.productionTip = false
Vue.component('layout-header', LayoutHeader);
Vue.component('layout-headercomponents', LayoutHeadercomponents);
Vue.component('layout-navbar', LayoutNavbar);
Vue.component('layout-navbaremail', LayoutNavbaremail);
Vue.use(VueToastify)
Vue.use(VueConfirmDialog)
Vue.use(VueSweetalert2)
Vue.use(Vlf, localforage)
const options = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
};

Vue.use(VueProgressBar, options);
Vue.prototype.$localStore = localforage.createInstance({storeName: 'dsms'})
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
/* eslint-disable no-new */
Vue.directive('select2', {
  inserted(el) {
    $(el).on('select2:select', () => {
      const event = new Event('change', { bubbles: true, cancelable: true });
      el.dispatchEvent(event);
    });

    $(el).on('select2:unselect', () => {
      const event = new Event('change', {bubbles: true, cancelable: true})
      el.dispatchEvent(event)
    })
  },
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  i18n,
})
